import { Component, OnInit, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { DataService } from 'src/app/Service/data.service';
declare var $: any;

import { MenuService } from '../../core/menu/menu.service';
import { SettingsService } from '../../core/settings/settings.service';

@Component({
    selector: 'app-subscriber-sidebar',
    templateUrl: './subscriber-sidebar.component.html',
    styleUrls: ['./subscriber-sidebar.component.scss']
})
export class SubscriberSidebarComponent implements OnInit {

    constructor(public menu: MenuService, private DataServiceObj: DataService, public settings: SettingsService, public injector: Injector) {

        this.subscribermenuItems = menu.getNewMenu();

    }

    subscribermenuItems: Array<any>;
    router: Router;
    sbclickEvent = 'click.sidebar-toggle';
    $doc: any = null;
    p = 1;
    term;
    response;
    permissions;
    menuItems: Array<any>;
    role: any;
    roleId: any;
    getSubscriberID: any;
    dvId: any;

    FinalData = [];

    ngOnInit() {

        this.router = this.injector.get(Router);

        this.router.events.subscribe((val) => {
            // close any submenu opened when route changes
            this.removeFloatingNav();
            // scroll view to top
            window.scrollTo(0, 0);
            // close sidebar on route change
            this.settings.setLayoutSetting('asideToggled', false);
        });

        // enable sidebar autoclose from extenal clicks
        this.anyClickClose();

        const UsersData = JSON.parse(sessionStorage.getItem('subscriberLogin'));
        console.log(UsersData);
        this.roleId = UsersData.Data.roleId;
        // Data.id is the txnUsers row id, not the subscriber id. Passing it to
        // getSubscriberData resolved whichever txnSubscribers row shares that number,
        // which is how a signed-in MRK user was shown another company's name.
        this.getSubscriberID = UsersData.token ? UsersData.Data.subscriberId : UsersData.Data.id;
        this.getRolePermissions(UsersData.Data);
        this.getPermission();
        this.getSubscriberDetails();

    }
    getRolePermissions(role: any) {
        const token = this.DataServiceObj.verifyToken();
        this.DataServiceObj.getRolePermissions('subscriber/rolePermission/getPermissionForSubscriber', role, token).subscribe(res => {
            // this.DataServiceObj.getRolePermissions('subscriber/rolePermission/getPermission',  role, token).subscribe(res => {
            this.response = res;
            console.log('resopneInitalfunct', res);
            // this.FinalData.push(this.subscribermenuItems[0])
            // this.FinalData.push({ text: "Home", link: "/home", icon: "icon-home" })
            // for (let i = 0; i < this.permissions.length; i++) {
            //     var result = this.subscribermenuItems.filter(x => x.text == this.permissions[i].module);
            //     this.FinalData.push(result[0])
            // }
            // let data = this.FinalData.filter(function (element) {
            //     return element !== undefined;
            // });
            // this.subscribermenuItems = data;
        }, err => {
        });
    }
    getSubscriberDetails() {
        const token = this.DataServiceObj.verifyToken();

        const data = {
          subscriberId: this.getSubscriberID
        };

        this.DataServiceObj.getDvId('admin/user/getSubscriberData', data, token).subscribe((res: any) => {
          console.log('testone', res);
          if (res.Status == 200)
          {
          this.response = res;
          this.dvId = this.response?.Data[0]?.dvID;
          if (this.dvId == null || this.dvId == undefined)
            {
                const list = this.subscribermenuItems.filter((v: any) => v.text != 'View Application');
                this.subscribermenuItems = list;

            }
        }
        }, (err: any) => {

        });
    }

    getPermission() {
        const roles = {
          id: this.roleId
        };
        const token = this.DataServiceObj.verifyToken();

        this.DataServiceObj.checkUserRole('admin/website_management/getsubscriberrRoles', roles, token).subscribe(res => {
          this.response = res;
          if (this.response.Status == 200)
          {
          this.role = this.response?.Data[0]?.role;
          console.log('Roles response', res);
          if (this.role != 'SusbcriberAdmin') {
            this.DataServiceObj.getRolePermissions('subscriber/rolePermission/getPermission', roles, token).subscribe((res) => {
              this.response = res;
              this.permissions = this.response.Data;
              console.log('permissions', res, this.subscribermenuItems);
              this.permissions = this.response.Data;
              this.FinalData.push(this.subscribermenuItems[0]);
              this.FinalData.push({ text: 'Home', link: '/home', icon: 'icon-home' });
              for (let i = 0; i < this.permissions.length; i++) {
                if (this.permissions[i].isEnabled > 0)
                {
                    if (this.permissions[i].module == 'Tenant Mangement')
                    {
                        this.permissions[i].module = 'Tenant Management';
                    }
                    if (this.permissions[i].module == 'Manage Users')
                    {
                        this.permissions[i].module = 'Users';
                    }
                    if (this.permissions[i].module == 'Reports')
                        {
                            this.permissions[i].module = 'Order Reports';
                        }

                    const result = this.subscribermenuItems.filter(x => x.text == this.permissions[i].module);
                    this.FinalData.push(result[0]);
                }

            }
              const data = this.FinalData.filter(function(element) {
                return element !== undefined;
            });
              this.subscribermenuItems = data;
              console.log('SUBSCRIBERmeNU', data, this.FinalData);

            },
              (err) => { }
            );
          } else {

          }
        }
        },
          (err) => { }
        );
        console.log('SUBSCRIBERmeNU', this.subscribermenuItems);

      }

    anyClickClose() {
        this.$doc = $(document).on(this.sbclickEvent, (e) => {
            if (!$(e.target).parents('.aside-container').length) {
                this.settings.setLayoutSetting('asideToggled', false);
            }
        });
    }

    ngOnDestroy() {
        if (this.$doc) {
            this.$doc.off(this.sbclickEvent);
        }
    }

    toggleSubmenuClick(event) {

        const ul = $(event.currentTarget.nextElementSibling);

        // Leaf items have no submenu — let routerLink handle navigation
        if (!ul.length) {
            return;
        }

        // Parent items use an empty href; always block reload (including collapsed/hover modes)
        event.preventDefault();

        if (!this.isSidebarCollapsed() && !this.isSidebarCollapsedText() && !this.isEnabledHover()) {

            // hide other submenus
            const parentNav = ul.parents('.sidebar-subnav');
            $('.sidebar-subnav').each((idx, el) => {
                const $el = $(el);
                // if element is not a parent or self ul
                if (el !== parentNav[0] && el !== ul[0]) {
                    this.closeMenu($el);
                }
            });

            // any child menu should start closed
            ul.find('.sidebar-subnav').each((idx, el) => {
                this.closeMenu($(el));
            });

            // toggle UL height
            const ulHeight = ul.css('height');
            if (ulHeight === 'auto' || parseInt(ulHeight, 10)) {
                this.closeMenu(ul);
            }
            else {
                // expand menu
                ul.on('transitionend', () => {
                    ul.css('height', 'auto').off('transitionend');
                }).css('height', ul[0].scrollHeight);
                // add class to manage animation
                ul.addClass('opening');
            }

        }

    }

    // Close menu collapsing height
    closeMenu(elem) {
        elem.css('height', elem[0].scrollHeight); // set height
        elem.css('height', 0); // and move to zero to collapse
        elem.removeClass('opening');
    }

    toggleSubmenuHover(event) {
        const self = this;
        if (this.isSidebarCollapsed() || this.isSidebarCollapsedText() || this.isEnabledHover()) {
            event.preventDefault();

            this.removeFloatingNav();

            const ul = $(event.currentTarget.nextElementSibling);
            const anchor = $(event.currentTarget);

            if (!ul.length) {
                return; // if not submenu return
            }

            const $aside = $('.aside-container');
            const $asideInner = $aside.children('.aside-inner'); // for top offset calculation
            const $sidebar = $asideInner.children('.sidebar');
            const mar = parseInt($asideInner.css('padding-top'), 0) + parseInt($aside.css('padding-top'), 0);
            const itemTop = ((anchor.parent().position().top) + mar) - $sidebar.scrollTop();

            const floatingNav = ul.clone().appendTo($aside);
            const vwHeight = document.body.clientHeight;

            floatingNav
                .addClass('nav-floating');

            // each item has ~40px height
            // multiply to force space for at least N items
            const safeOffsetValue = (40 * 5);
            const navHeight = floatingNav.outerHeight(true) + 2; // 2px border
            const safeOffset = navHeight < safeOffsetValue ? navHeight : safeOffsetValue;

            const displacement = 25; // displacement in px from bottom

            // if not enough space to show N items, use then calculated 'safeOffset'
            const menuTop = (vwHeight - itemTop > safeOffset) ? itemTop : (vwHeight - safeOffset - displacement);

            floatingNav
                .removeClass('opening') // necesary for demo if switched between normal//collapsed mode
                .css({
                    position: this.settings.getLayoutSetting('isFixed') ? 'fixed' : 'absolute',
                    top: menuTop,
                    bottom: (floatingNav.outerHeight(true) + menuTop > vwHeight) ? (displacement + 'px') : 'auto'
                });

            floatingNav
                .on('mouseleave', () => { floatingNav.remove(); })
                .find('a').on('click', function(e) {
                    e.preventDefault(); // prevents page reload on click
                    // get the exact route path to navigate
                    const routeTo = $(this).attr('route');
                    if (routeTo) { self.router.navigate([routeTo]); }
                });

            this.listenForExternalClicks();

        }

    }

    listenForExternalClicks() {
        const $doc = $(document).on('click.sidebar', (e) => {
            if (!$(e.target).parents('.aside-container').length) {
                this.removeFloatingNav();
                $doc.off('click.sidebar');
            }
        });
    }

    removeFloatingNav() {
        $('.nav-floating').remove();
    }

    isSidebarCollapsed() {
        return this.settings.getLayoutSetting('isCollapsed');
    }
    isSidebarCollapsedText() {
        return this.settings.getLayoutSetting('isCollapsedText');
    }
    isEnabledHover() {
        return this.settings.getLayoutSetting('asideHover');
    }
}

